import { render, staticRenderFns } from "./Compre.vue?vue&type=template&id=ed06fe00&"
import script from "./Compre.vue?vue&type=script&lang=js&"
export * from "./Compre.vue?vue&type=script&lang=js&"
import style0 from "./Compre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports